import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getAccountSubscription } from "../selectors/currentAccountSelector.ts";
import styles from "../styles/ProfileProduct.module.scss";
import shared from "../styles/UserProfileCommon.module.scss";
import { redirectToPlans } from "../utils/routes";
import { updateDeviceStatus } from "../api/account";
import currentUserInfo from "../selectors/currentUserInfo";
import selectUserTokens from "../selectors/selectUserTokens";
import { validateToken } from "../actions/auth";
import { fetchAccountData } from "../actions/account.ts";
import { openNewWindow } from "../utils/helperUtils";
import isLoggingInFromClient from "../selectors/isLoggingInFromClient";
import { storeSSOTokens } from "../api/auth";
export default function ProfileProductPage(props) {
  const dispatch = useDispatch();
  const clientLoginState = useSelector(isLoggingInFromClient);
  const { match } = props;
  const product = match.params.product;
  const currentUser = useSelector(currentUserInfo);
  const authTokens = useSelector(selectUserTokens);
  const subscriptionData = useSelector(getAccountSubscription);
  const planData = subscriptionData.find((plan) => {
    return plan.planName === product;
  });
  const planInfo = planData ? planData.selectedPlanSpecs : null;

  async function fetchData() {
    await dispatch(fetchAccountData());
  }

  useEffect(() => {
    if (currentUser) {
      fetchData();
    }
    //eslint-disable-next-line
  }, [currentUser]);

  async function fetchSSOToken() {
    const { accessToken, refreshToken } = authTokens;
    const token = await storeSSOTokens(
      process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
      "",
      accessToken,
      refreshToken
    );
    return token;
  }

  async function deactiveDeviceClicked(hash) {
    console.log("deactiveDeviceClicked with product = ", product, "plandata.product = ", planData.product)
    const refreshedToken = await dispatch(validateToken());
    try {
      await updateDeviceStatus(refreshedToken, currentUser.uuid, false, hash, planData.product);
      fetchData();
      toast.success("Device was sucessfully deactivated!");
    } catch (err) {
      toast.error(err);
    }
  }

  async function handleUpgradeClick(planData) {
    const ssoToken = await fetchSSOToken();
    if (clientLoginState) {
      openNewWindow(
        `${
          process.env.REACT_APP_DOMAIN_URL
        }/sso_plans?token=${ssoToken}&view=${planData.product.toLowerCase()}`,
        false
      );
    } else {
      redirectToPlans(props, planData.product);
    }
  }

  function renderTableData() {
    console.log("renderTableData with planData = ", planData)
    if (planData?.devices) {
      const { devices } = planData;
      return devices.map((device, index) => {
        return (
          <tr key={index}>
            <td>
              {/* <img
                src={renderOSIcon(device.operatingSystem)}
                alt=""
                className={styles.deviceIcon}
              /> */}
              {device.Name}
            </td>
            {/* <td>{device.location}</td> */}
            <td>{device.Active.toString()}</td>
            {/* <td>{device.operatingSystem}</td>
            <td>{device.IPAddress}</td> */}
            {device.Active && (
              <td>
                <button
                  className={styles.deleteBtn}
                  onClick={() =>
                    deactiveDeviceClicked(device.MACAddressHash)
                  }
                >
                  Deactivate Device
                  <img
                    src="https://frontend-assets.buildbox.com/x.png"
                    alt="device-delete-icon"
                    className={styles.deleteIcon}
                  />
                </button>
              </td>
            )}
          </tr>
        );
      });
    } else {
      return null;
    }
  }

  function renderMobileTableData() {
    if (planData?.devices) {
      const { devices } = planData;
      return devices.map((device, index) => {
        return (
          <div key={index} className={styles.deviceDetails}>
            <div>
              <h6>Device</h6>
              <span>
                {/* <img
                  src={renderOSIcon(device.operatingSystem)}
                  alt=""
                  className={styles.deviceIcon}
                /> */}
                {device.Name}
              </span>
            </div>
            {/* <div>
              <h6>Location</h6>
              <span>{device.location}</span>
            </div> */}
            <div>
              <h6>Is Active</h6>
              <span>{device.Active.toString()}</span>
            </div>
            {/* <div>
              <h6>Operating System</h6>
              <span>{device.operatingSystem}</span>
            </div>
            <div>
              <h6>IP Address</h6>
              <span>{device.IPAddress}</span>
            </div> */}
            {device.Active && (
              <div>
                <button
                  className={styles.deleteBtn}
                  onClick={() =>
                    deactiveDeviceClicked(device.MACAddressHash)
                  }
                >
                  Deactivate Device
                  <img
                    src="https://frontend-assets.buildbox.com/Vector+(1).svg"
                    alt="device-delete-icon"
                    className={styles.deleteIcon}
                  />
                </button>
              </div>
            )}
          </div>
        );
      });
    } else {
      return null;
    }
  }

  function renderSupportModules() {
    if (planData?.selectedPlanSpecs) {
      const { supportedModules } = planData.selectedPlanSpecs;
      return supportedModules.map((modules, index) => {
        return (
          <li key={index} className={styles.moduleItems}>
            {modules}
          </li>
        );
      });
    } else {
      return null;
    }
  }

  return (
    <div className={styles.profileProductWrapper}>
      <h1>{product}</h1>
      {/* NOTE: soundbox doesn't have plan details */}
      {!product.toLowerCase().includes("soundbox") && (
      <div className={styles.subHeader}>
        <h2>Details</h2>
        <div>
          <div className={styles.productSubText}>
            Supported Modules of Current License:
            <ul className={styles.moduleList}>{renderSupportModules()}</ul>
          </div>
          <div className={styles.productDetailsLabel}>
            <span>Available Worlds: </span>
            <b>
              {planInfo?.availableWorlds < 0
                ? "Unlimited"
                : planInfo?.availableWorlds}
            </b>
          </div>
          <div className={styles.productDetailsLabel}>
            <span> Available Scenes: </span>
            <b>
              {planInfo?.availableSections > 0
                ? planInfo?.availableSections
                : "Unlimited"}
            </b>
          </div>
          <div className={styles.productDetailsLabel}>
            <span>Branded Splash Screens: </span>
            <b>
              {planInfo?.brandedSplashScreen ? "Available" : "Not Available"}
            </b>
          </div>
        </div>
        {planData?.upgradeAvailable && (
          <button
            className={styles.upgradeBtn}
            onClick={() => handleUpgradeClick(planData)}
          >
            Upgrade
          </button>
        )}
      </div>
      )}
      <div className={styles.subHeader}>
        <h2>Devices</h2>
        <div className={styles.productTopSubText}>
          These devices are linked to your personal account
        </div>
        <hr className={shared.dividerLine} />
        <div>
          <table className={styles.desktopTable}>
            <thead>
              <tr>
                <th>Devices</th>
                {/* <th>Location</th> */}
                <th>Is Active</th>
                {/* <th>Operating System</th>
                <th>IP Address</th> */}
                <th />
              </tr>
            </thead>
            <tbody>{renderTableData()}</tbody>
          </table>
          <div className={styles.mobileTable}>{renderMobileTableData()}</div>
          {/* <div className={styles.productSubText}>
            Your plan supports up to 3 device seats, but you can add more
            anytime
          </div> */}
        </div>
        {/* <button className={styles.upgradeBtn}>Add Seats</button> */}
      </div>
    </div>
  );
}
